<script setup lang="ts">
interface Props {
  name: string;
}

const props = defineProps<Props>();
const attrs = useAttrs();

const isFlagIcon = computed(() => props.name?.startsWith('flags/'));
const flagCode = computed(() => props.name?.replace('flags/', ''));

const getFlagUrl = () => {
  return `/assets/icons/flags/${flagCode.value}.svg`;
};

const handleFlagError = () => {
  console.warn(
    `Erro ao carregar bandeira ${flagCode.value}, mantendo NuxtIcon como fallback`,
  );
  // O fallback já está coberto pelo v-else no template
};

const imageClasses = computed(() => {
  // Se não há classes específicas, usar tamanho padrão para consistência com NuxtIcon
  return attrs.class || 'w-4 h-4';
});

const imageStyles = computed(() => {
  // Forçar tamanho do SVG para sobrescrever dimensões intrínsecas
  return {
    width: '16px',
    height: '16px',
    objectFit: 'contain' as const,
  };
});
</script>

<template>
  <img
    v-if="isFlagIcon"
    :alt="`Bandeira de ${flagCode}`"
    :class="imageClasses"
    loading="lazy"
    :src="getFlagUrl()"
    :style="imageStyles"
    @error="handleFlagError"
  />
  <NuxtIcon
    v-else
    :name="name"
    v-bind="attrs"
  />
</template>
